import app from '../../app';
import { KeyValueGambit } from '../IGambit';
export default class CreatedGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('core.lib.gambits.discussions.created.key', {}, true);
  }
  hint() {
    return app.translator.trans('core.lib.gambits.discussions.created.hint', {}, true);
  }
  valuePattern() {
    return '(\\d{4}\\-\\d\\d\\-\\d\\d(?:\\.\\.(\\d{4}\\-\\d\\d\\-\\d\\d))?)';
  }
  filterKey() {
    return 'created';
  }
}
flarum.reg.add('core', 'common/query/discussions/CreatedGambit', CreatedGambit);